"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTotalWaitTime = void 0;
const calculate_call_wait_time_1 = require("./calculate-call-wait-time");
function calculateTotalWaitTime(calls) {
    return calls.reduce((totalWaitTime, call) => totalWaitTime + (0, calculate_call_wait_time_1.calculateCallWaitTime)(call), 0);
}
exports.calculateTotalWaitTime = calculateTotalWaitTime;
